import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import { urgenciaFirmar, usosIdeales } from 'assets'
import { LandingButton, NunaLabel } from 'components'
import { COLORS, IDEAL_USES_CONST } from 'const'
import { motion } from 'framer-motion'
import {
  containerVariants,
  landingButtonPrimary,
  normalTextStyle,
  sliderBrandTitle,
  titleTextStyle,
} from 'styles'

const whatsappLink = process.env.REACT_APP_WHATSAPP_LINK!
export const BlogSection = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      id="blog"
      component={motion.div}
      initial="offscreen"
      whileInView="onscreen"
      variants={containerVariants}
      viewport={{ once: true }}
    >
      <Box
        sx={{
          bgcolor: '#f7f7f7ff',
          px: { xs: 4, md: 13, lg: 30, xl: 15 },
          py: { xs: 8, md: 10, lg: 20 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            ...titleTextStyle,
            fontFamily: 'Poppins',
            fontWeight: 600,
            textAlign: 'center',
            maxWidth: { xs: '75%', md: '75%', xl: '65%' },
            fontSize: { xs: '2rem', md: '3rem' },
            fontBold: 600,
            color: '#4363A2',
          }}
        >
          ¿Necesitas firmar un documento con urgencia y no cuentas con una firma electrónica?
        </Typography>

        <Box
          component="img"
          src={urgenciaFirmar}
          alt={'Necesitar firmar un documento con urgencia y no cuentas con una firma electrónica?'}
          sx={{
            width: '100%',
            borderRadius: { xs: 5, md: 10, lg: 20 },
            maxHeight: { xs: 300, lg: 400 },
            objectFit: 'cover',
            fontSize: { xs: '1rem', md: '1rem', xl: '1.5rem' },
          }}
        />
        <Grid container spacing={2} my={1}>
          <Grid
            size={{ xs: 12, md: 5, xl: 6 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' },
              justifyContent: { sx: 'center', md: 'flex-start' },
            }}
          >
            <NunaLabel
              title="NUNA EXPRESS"
              sxImgProps={isMobile ? { width: 35, height: 35 } : {}}
              sxTextProps={isMobile ? { fontSize: '1.8rem' } : { fontSize: '3rem' }}
            />
            <Typography
              sx={{
                ...sliderBrandTitle,
                color: COLORS.text.black,
                lineHeight: 1,
                fontSize: { xs: '1.8rem', md: '2.75rem', xl: '3rem' },
              }}
            >
              personal
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 7, lg: 6 }}>
            <Typography
              sx={{
                ...normalTextStyle,
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              Con Nuna Express eso ya no es un problema, ahora en segundos, validamos tu identidad
              mediante un proceso biométrico seguro, generamos un certificado de un solo uso así
              puedes firmar cualquier documento urgente desde cualquier dispositivo y con total
              validez legal.
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          backgroundColor: '#eaeaeaff',
          borderRadius: '50px 50px 0 0',
          mt: -5,
          px: { xs: 4, md: 13, lg: 30, xl: 15 },
          py: { xs: 8, md: 10, lg: 20 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5,
        }}
      >
        <Grid container spacing={10}>
          <Grid size={{ xs: 12, md: 5, xl: 6 }}>
            <Typography
              variant="h4"
              sx={{ ...sliderBrandTitle, color: COLORS.text.black, fontWeight: 600, mb: 3 }}
            >
              Uso ideal en:
            </Typography>
            {IDEAL_USES_CONST.map((use) => (
              <Box key={use.title} sx={{ my: 2 }}>
                <Typography
                  sx={{
                    ...normalTextStyle,
                    fontWeight: 'bold',
                  }}
                >
                  {use.title}
                </Typography>
                <Typography
                  sx={{
                    ...normalTextStyle,
                    lineHeight: 1.25,
                  }}
                >
                  {use.description}
                </Typography>
              </Box>
            ))}
            <LandingButton
              text={'COMIENZA AHORA'}
              style={{
                ...landingButtonPrimary,
                backgroundColor: COLORS.button.second,
                borderRadius: '30px',
                mt: 2,
                px: {
                  xs: 3,
                  md: 4,
                },
                width: 'fit-content',
              }}
              onClick={() => {
                window.open(whatsappLink, '_blank')
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 7, xl: 6 }}>
            <Box
              component="img"
              src={usosIdeales}
              alt={
                'Necesitar firmar un documento con urgencia y no cuentas con una firma electrónica?'
              }
              sx={{
                width: '100%',
                height: '100%',
                borderRadius: 10,
                objectFit: 'cover',
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
